"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getColoradoRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _types = require("../../assets/types");

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'CO';

function getColoradoRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Motor Vehicle (one vehicle)',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (j)(I); Colo. Rev. Stat. § 13-54-102 (j)(II)',
    limitAggregateSingle: 7500,
    limitAggregateJoint: 15000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _types.VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods and Furnishings, Appliances',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(e); Colo. Rev. Stat. § 13-54-101(4)',
    limitAggregateSingle: 3000,
    limitAggregateJoint: 6000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.PERSONAL && [_subTypes.ELECTRONICS, _subTypes.HOUSEHOLD].includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Books, Antiques, Art, Collectibles',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(c)',
    limitAggregateSingle: 2000,
    limitAggregateJoint: 4000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.BOOK || subType === _subTypes.ANTIQUE || subType === _subTypes.ARTWORK || subType === _subTypes.COLLECTIBLES);
    }
  }, {
    id: idCounter.increment(),
    description: 'Wearing Apparel',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(a)',
    limitAggregateSingle: 2000,
    limitAggregateJoint: 4000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CLOTHES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Jewelry, Adornments',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(b)',
    limitAggregateSingle: 2500,
    limitAggregateJoint: 5000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.WATCH || subType === _subTypes.JEWELRY || subType === _subTypes.WEDDING_RINGS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Health aids',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(p)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Food and fuel',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(f)',
    limitAggregateSingle: 600,
    limitAggregateJoint: 1200,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FOOD_AND_FUEL;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Employees Pensions',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 24-51-212; Colo. Rev. Stat. § 24-52-102(4)',
    limitAggregateSingle: 300,
    limitAggregateJoint: 600,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTypes = [_tertiaryTypes.DISTRICT_EMPLOYEES_PENSION, _tertiaryTypes.PUBLIC_EMPLOYEE_PENSION, _tertiaryTypes.STATE_EMPLOYEES_PENSION];
      return this.canTakeMoreExemptions() && validTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA (employee retirement account)',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(s)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Police pensions',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 31-30.5-208; Colo. Rev. Stat. § 31-31-203',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.POLICE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'IRA & Rotha IRA',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(s)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.ROTH_IRA || subType === _subTypes.IRA);
    }
  }, {
    id: idCounter.increment(),
    description: 'Firefighters pensions',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 31-30.5-208; Colo. Rev. Stat. § 31-31-203',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.FIREFIGHTERS_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Security deposits',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(r); Colo. Rev. Stat. § 38-12-102',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.SECURITY_DEPOSIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony and child support kept separate from other assets',
    type: stateCode,
    requiresReview: true,
    statuteName: 'Colo. Rev. Stat. § 13-54-102.5; Colo. Rev. Stat. § 13-54-102 (u)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Earned Income Tax Credit or Child Credit',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(o)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.INCOME_TAX_CREDIT || tertiaryType === _tertiaryTypes.CHILD_CREDIT);
    }
  }, {
    id: idCounter.increment(),
    description: 'Wages - greater of min 75% weekly or 30 times federal or state min wage',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-104',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability benefits',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (v)',
    limitAggregateSingle: 4000,
    limitAggregateJoint: 8000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public assistance',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 26-2-131',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Crime victims\' compensation',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 24-4.1-114; Colo. Rev. Stat. § 13-54-102 (1)(q)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 8-80-103',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Veterans\' Benefit',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(h)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal benefit',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. §10-14-403',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Workers Compensation',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 8-42-124',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Settlement',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(n)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Damaged property proceeds',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(m)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.DAMAGED_PROPERTY_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Accident Insurance - to $200 per month',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 10-16-212',
    limitAggregateSingle: 200,
    limitAggregateJoint: 400,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.ACCIDENT_INSURANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life insurance (cash surrender)',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(l)',
    limitAggregateSingle: 100000,
    limitAggregateJoint: 200000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _tertiaryTypes.WHOLE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (group)',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. §10-7-205',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.GROUP_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Homeowners\' insurance proceeds - to homestead amount',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 38-41-209',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.HOMEOWNERS_INSURANCE_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Office equipment, furnishings, and supplies, Tools of Trade, Stock in Trade',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(i)',
    limitAggregateSingle: 30000,
    limitAggregateJoint: 60000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.OFFICE_EQUIPMENT || subType === _subTypes.TOOLS_OF_TRADE || subType === _subTypes.LIMITED_LIABILITY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Professional\'s library (if not claimed under tools of trade exemption)',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(k)',
    limitAggregateSingle: 3000,
    limitAggregateJoint: 6000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.PROFESSIONAL_LIBRARY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Animals, livestock, crops, farming equipment, agricultural supplies',
    type: stateCode,
    statuteName: 'Colo. Rev. Stat. § 13-54-102 (1)(g)',
    limitAggregateSingle: 1000,
    limitAggregateJoint: 2000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.FARM_ANIMALS, _subTypes.CROPS, _subTypes.FARMING_EQUIPMENT, _subTypes.FARMING_SUPPLIES];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }];
}